<script>
    import FileUploadBase from "./FileUpload";
    import axios from "axios";
    import urls from "../urls";
    window.axios = axios; //Hack to make the S3BlobUploader work
    const S3BlobUploader = require('../../external/S3BlobUploader');

    export default {
        extends: FileUploadBase,
        name: "FileUpload",
        data: function () {
            return {
                //Base of 20mb
                'uploader': null,
            }
        },
        computed: {
            enableCancelButton(){return this.progress >= 0},
        },
        mounted() {
            this.createUploader();
        },
        methods: {
            async upload() {
                if(!this.validateInput()) {
                    return;
                }
                this.$gtag.event('upload', {event_category: 'File', event_label: this.file.name});

                let me = this;
                //From External JS Example
                this.uploader.on('beforeUpload', function() {
                    console.log('preparing upload');
                });
                this.uploader.on('startUpload', function() {
                    console.log('upload starting');
                    me.progress = 0
                });
                this.uploader.on('progress', function(data) {
                    console.log(data);
                    me.progress = data * 100
                });
                this.uploader.on('finishing', function() {
                    console.log('Upload complete, preparing final file');
                    me.progress = 101;
                });
                this.uploader.on('complete', function(data) {
                    console.log('We did it!', data);
                    me.progress = -1;
                    me.successMessage = "File uploaded successfully";
                    me.$store.dispatch('files/getFiles');
                    me.createUploader();
                });
                this.uploader.on('error', function(data) {
                    me.progress = -1;
                    this.successMessage = '';
                    console.log('failed', data);
                    me.errors.push("Upload failed");
                    me.createUploader();
                });
                this.uploader.on('cancel', function(data) {
                    console.log('cancelled', data);
                    me.errors.push("Upload Canceled");
                    me.createUploader();
                });

                this.progress = 101;
                this.uploader.start(this.file, this.description, this.selectedOrganization);
            },
            cancel() {
                this.progress = -1;
                this.uploader.abort();
            },
            createUploader() {
                this.uploader = new S3BlobUploader({server_url: urls.multipart_upload, method: 'POST', partSize: 20 * 1024 * 1024});
            },
        },
    }
</script>

<style scoped>

</style>
